import { useReveal } from '../lib/useReveal';

/**
 * Wraps children in a scroll-reveal element. Adds the `.reveal` class (animated
 * via index.css) and toggles `in-view` when scrolled into view, once.
 *
 * Props:
 *  - as: element tag to render (default 'div')
 *  - delay: optional stagger delay in ms (applied as inline transition-delay)
 *  - className: extra classes merged after `reveal`
 *  - threshold / rootMargin: forwarded to the observer
 *
 * Reduced motion is honored globally in index.css (forces visible / no transform).
 */
export default function Reveal({
  as: Tag = 'div',
  delay = 0,
  className = '',
  threshold,
  rootMargin,
  style,
  children,
  ...rest
}) {
  const ref = useReveal({ threshold, rootMargin });
  return (
    <Tag
      ref={ref}
      className={`reveal ${className}`.trim()}
      style={delay ? { transitionDelay: `${delay}ms`, ...style } : style}
      {...rest}
    >
      {children}
    </Tag>
  );
}
